
import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import axios from 'axios'

function PrintItemDetail() {
  return (
       <div className='main-section'>

           <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                 <h3 className='my-3 fw-bold fs-5 golos'>Print</h3>
                 
           </div>
       </div>
  )
}

export default PrintItemDetail